import { render, staticRenderFns } from "./ContactDetail.vue?vue&type=template&id=141d6a18"
import script from "./ContactDetail.vue?vue&type=script&lang=js"
export * from "./ContactDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('141d6a18')) {
      api.createRecord('141d6a18', component.options)
    } else {
      api.reload('141d6a18', component.options)
    }
    module.hot.accept("./ContactDetail.vue?vue&type=template&id=141d6a18", function () {
      api.rerender('141d6a18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contact/ContactDetail.vue"
export default component.exports